module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/export-8b211a81c5801004708f42a9b7be6b42.png";